var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.09938 6.00009L11.7719 1.32729C12.076 1.02334 12.076 0.531906 11.7719 0.22796C11.468 -0.0759865 10.9766 -0.0759865 10.6726 0.22796L5.99993 4.90076L1.32737 0.22796C1.02329 -0.0759865 0.532001 -0.0759865 0.228062 0.22796C-0.0760205 0.531906 -0.0760205 1.02334 0.228062 1.32729L4.90062 6.00009L0.228062 10.6729C-0.0760205 10.9768 -0.0760205 11.4683 0.228062 11.7722C0.379533 11.9238 0.578696 12 0.777716 12C0.976736 12 1.17576 11.9238 1.32737 11.7722L5.99993 7.09942L10.6726 11.7722C10.8242 11.9238 11.0233 12 11.2223 12C11.4213 12 11.6203 11.9238 11.7719 11.7722C12.076 11.4683 12.076 10.9768 11.7719 10.6729L7.09938 6.00009Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.137479093b6af21741fbfa8fb0fd7f13.svg";
export { ForwardRef as ReactComponent };